import { render, staticRenderFns } from "./NhlProjection.vue?vue&type=template&id=3aa10bb8&scoped=true"
import script from "./NhlProjection.vue?vue&type=script&lang=js"
export * from "./NhlProjection.vue?vue&type=script&lang=js"
import style0 from "./NhlProjection.vue?vue&type=style&index=0&id=3aa10bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa10bb8",
  null
  
)

export default component.exports